module.exports = {
  date_range: '%{date} - %{startTime} bis %{endTime} Uhr',
  participants: '1 Teilnehmer | %{n} Teilnehmer',
  sortLabels: {
    topic_asc: 'Alphabetisch (A-Z)',
    topic_desc: 'Alphabetisch (Z-A)',
    starts_at_asc: 'Datum (älteste zuerst)',
    starts_at_desc: 'Datum (neuste zuerst)',
  },
  sortShortLabels: {
    topic_asc: 'A-Z',
    starts_at_asc: 'Älteste',
    starts_at_desc: 'Neuste',
    topic_desc: 'Z-A',
  },
  search_webinar: 'Webinar suchen',
  active_webinars: 'Aktuell',
  open: 'Geöffnet',
  open_app_new_window: 'Lernsoftware in neuem Fenster öffnen',
  sure_to_leave: 'Möchtest du das Webinar verlassen?',
  currently_no_learningrooms_visible: 'Hier gibt es aktuell keine Lernräume.',
  currently_no_webinars_visible: 'Hier gibt es aktuell keine Webinare.',
  recordings: 'Aufzeichnungen',
  recordings_title: 'Aufzeichnungen älterer Webinare',
  join_webinar: 'Webinar beitreten',
  join_learningroom: 'Lernraum betreten',
  live: 'Jetzt live',
  learningrooms: 'Lernräume',
  learningroom: 'Lernraum',
  webinar: 'Webinar',
  leave_title: 'Webinar verlassen',
  leave: 'Webinar verlassen',
  webinars: 'Webinare',
}
